module.exports = __webpack_public_path__ + "static/media/mangosauce.c4647abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/mangosauce.jpg
// module id = 147
// module chunks = 0